import React from "react";
import Stack from "@mui/material/Stack";
import { useHistory } from "react-router-dom";
import { Avatar, Paper, Typography } from "@mui/material";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import HeightBox from "../components/HeightBox";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { WHITE, EMPLOYEE_BLUE } from "../colors";
import UserActivitiesContainer from "./UserActivitiesContainer";
import Chip from '@mui/material/Chip';
import { getAge } from "../util/calculations.utils";
import {
  AFFIDAVIT_FORM,
  APPLICATION_FORM,
  LETTER,
  POLICE_FORM,
} from "../constants/formTypes";
import { FORM_SUBMIT_ROUTE } from "../routes";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import UserRemarksContainer from "./UserRemarksContainer";

const Container = styled(Paper)(({ theme }) => ({
  backgroundColor: WHITE,
  borderRadius: 10,
  display: "flex",
  flexDirection: "row",
  justifyContent: "center",
  alignItems: "center",
  boxShadow: "0px 5px 20px rgba(0, 0, 0, 0.05)",
}));

const Customcontainer = styled(Paper)(({ theme }) => ({
  backgroundColor: WHITE,
  borderRadius: 10,
  paddingTop: 20,
  paddingBottom: 20,
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-around",
  paddingLeft: 40,
  boxShadow: "0px 5px 20px rgba(0, 0, 0, 0.05)",
}));

const CustomButton = styled(Button)(({ theme }) => ({
  paddingLeft: 10,
  height: 50,
  minWidth: 280,
  color: WHITE,
  textTransform: "none",
  fontSize: 18,
  fontWeight: 700,
  borderRadius: 10,
}));

const CustomTypography = styled(Typography)(({ theme }) => ({
  fontSize: 14,
}));

const CustomSelect = styled(Select)(({ theme }) => ({
  height: 42,
  minWidth: 312,
  backgroundColor: WHITE,
  boxShadow: "0px 5px 20px rgba(0, 0, 0, 0.05)",
  outline: "none",
  borderRadius: 10,
  border: "0px solid #fff",
  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
    border: "0px solid #484850",
  },
  "&:hover": {
    border: "0px solid #484850",
  },
  "&:focus-within": {
    border: "0px solid #484850",
  },
  "& .MuiOutlinedInput-notchedOutline": {
    border: "0px solid #484850",
  },
  "&:hover .MuiOutlinedInput-notchedOutline": {
    border: "0px solid #484850",
  },
}));
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
export default function SingleUserDetailsContainerEmp(props) {
  const { user } = props;
  const history = useHistory();

  const [activityType, setActivityType] = React.useState("");
  const [valueTab, setValueTab] = React.useState(0);

  const handleActivityTabChange = (event, newValue) => {
    setValueTab(newValue);
  };

  const handleChange = (event) => {
    setActivityType(event.target.value);
  };
  return (
    <div>
      <HeightBox height={20} />
      <Stack direction="row" spacing={5}>
        <div>
          {/* <Typography fontSize={15} fontWeight={600}>
            {user?.name || user?.full_name}
          </Typography> */}
                <Chip size="small" color="primary" label={user?.Role?.name} />
          <HeightBox height={10} />
          <Container elevation={0} style={{ width: 226, height: 192 }}>
            <Avatar
              sx={{ width: 130, height: 130 }}
              src={
                user?.imagePath ||
                user?.passport_size_image ||
                user?.full_size_image ||
                "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=80"
              }
            />
          </Container>
        </div>
        <div>
          <Typography fontSize={18} fontWeight={700}>
            Personal Details
          </Typography>
          <HeightBox height={10} />
          <Customcontainer style={{ width: 650, height: 192 }}>
            <Stack direction="row" spacing={2}>
              <CustomTypography>Name : </CustomTypography>
              <CustomTypography>
                {user?.name || user?.full_name}
              </CustomTypography>
            </Stack>
            <Stack direction="row" spacing={2}>
              <CustomTypography>Birthday : </CustomTypography>
              <CustomTypography>{user?.dob}</CustomTypography>
            </Stack>
            <Stack direction="row" spacing={2}>
              <CustomTypography>Address : </CustomTypography>
              <CustomTypography>{user?.address}</CustomTypography>
            </Stack>
            <Stack direction="row" spacing={2}>
              <CustomTypography>Age : </CustomTypography>
              <CustomTypography>{getAge(user?.dob)}</CustomTypography>
            </Stack>
            <Stack direction="row" spacing={2}>
              <CustomTypography>Note : </CustomTypography>
              <CustomTypography>{user?.note}</CustomTypography>
            </Stack>
          </Customcontainer>
        </div>

      </Stack>
      <HeightBox height={20} />

      <HeightBox height={20} />
      <Box sx={{ width: "100%",backgroundColor:WHITE,opacity:0.9,borderRadius:4 }}>
        <Box sx={{ borderBottom: 0 }}>
          <Tabs
            value={valueTab}
            onChange={handleActivityTabChange}
            aria-label="basic tabs example"
            sx={{
              backgroundColor:WHITE,
              borderRadius:2
            }}
          >
            <Tab label="Activities" {...a11yProps(0)} />
            <Tab label="Remarks" {...a11yProps(1)} />
          </Tabs>
        </Box>
        <TabPanel value={valueTab} index={0}>
          <Stack direction="row" spacing={5}>
            <div>
              <HeightBox height={5} />
              <Typography fontSize={18} fontWeight={700}>
                Activities
              </Typography>
            </div>

            <CustomSelect
              labelId="demo-simple-select-standard-label"
              id="demo-simple-select-standard"
              onChange={handleChange}
              defaultValue="All"
            >
              <MenuItem value="All">All</MenuItem>
              <MenuItem value={APPLICATION_FORM}>Application form</MenuItem>
              <MenuItem value={POLICE_FORM}>Police form</MenuItem>
              <MenuItem value={AFFIDAVIT_FORM}>Affidavit form</MenuItem>
            </CustomSelect>
          </Stack>
          <HeightBox height={20} />
          <UserActivitiesContainer
            userId={user.id}
            activityType={activityType}
            userRole={props.userRole}
          />
        </TabPanel>
        <TabPanel value={valueTab} index={1}>
          <UserRemarksContainer
            userId={user.id}
            activityType={activityType}
            userRole={props.userRole}
          />
        </TabPanel>
      </Box>
    </div>
  );
}
